import { validateDomainAllowlist } from './domain-allowlist'

export const modifyEnrichApiLimitsValidator = values => {
  const errors: Record<string, any> = {}

  if (!values.quota) errors.quota = 'Requests limit is required'

  const domainError = validateDomainAllowlist(values.publicApiKeyDomainAllowlist)
  if (domainError) errors.publicApiKeyDomainAllowlist = domainError

  return errors
}
